/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_WristInputs */

const en_us2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wrist`)
};

const pt_br2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`punho`)
};

const es_419_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muñeca`)
};

const pt_pt2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pulso`)
};

const fr_fr2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`poignet`)
};

const de_de2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handgelenk`)
};

const it_it2_catalog_movement_wrist = /** @type {(inputs: Catalog_Movement_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`polso`)
};

/**
* | output |
* | --- |
* | "wrist" |
*
* @param {Catalog_Movement_WristInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_wrist = /** @type {((inputs?: Catalog_Movement_WristInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_WristInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_wrist(inputs)
	if (locale === "es-419") return es_419_catalog_movement_wrist(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_wrist(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_wrist(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_wrist(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_wrist(inputs)
	return en_us2_catalog_movement_wrist(inputs)
});
export { catalog_movement_wrist as "catalog.movement.wrist" }